<template>
	<el-container class="min-width">
		<el-header>{{ unitName }}</el-header>
		<el-container>
			<el-aside v-if="!$route.meta.hideMenu" width="260px"><Aside /></el-aside>
			<el-container>
				<el-main>
					<keep-alive><router-view v-if="$route.meta.keepAlive" /></keep-alive>
					<router-view v-if="!$route.meta.keepAlive"></router-view>
				</el-main>
				<div v-if="name" class="copyright"><a style="text-decoration: none; color:black" target="_blank" href="https://beian.miit.gov.cn/ ">渝ICP备2024041183号-1</a>&nbsp;&nbsp;&nbsp;&nbsp;{{ name }} ©版权所有<br></div>
			</el-container>
		</el-container>
	</el-container>
</template>

<script>
import Aside from './Aside.vue';
import { mapState } from 'vuex';
export default {
	components: {
		Aside
	},
	computed: {
		...mapState({
			unitName: state => state.system.unitName,
			name: state => state.system.examInfo.name
		})
	}
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/color.scss';
.min-width {
	min-width: 1200px;
}
.el-header {
	background-color: $--color-primary;
	box-shadow: 0px 2px 7px 0px rgba(0, 0, 0, 0.04);
	font-size: 28px;
	color: #ffffff;
	line-height: 60px;
	padding-left: 80px;
}

.el-main {
	position: relative;
	background-color: #fff;
}
.copyright {
	position: fixed;
	bottom: 5px;
	left: 50%;
	transform: translateX(-50%);
	font-size: 14px;
}
</style>
